export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8889.37e8f510.jpg";